export default "__VITE_ASSET__YCLLJyzg__"